module.exports = __webpack_public_path__ + "static/media/delete-red.54c976f6.svg";